import React from 'react';
import LegalLayout from './LegalLayout';

// PLATZHALTER-AGB für die SaaS-Nutzung. Vor dem Onboarding zahlender Kunden
// bitte von einem Anwalt prüfen lassen oder eRecht24-AGB-Generator nutzen.
const AGB = () => (
  <LegalLayout title="Allgemeine Geschäftsbedingungen">
    <p className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded px-3 py-2 mb-6">
      <strong>Hinweis:</strong> Diese AGB sind ein Platzhalter und decken den
      Status während der Beta-Phase ab. Vor dem Verkauf an zahlende Kunden
      werden sie durch eine anwaltlich geprüfte Fassung ersetzt.
    </p>

    <h2>§ 1 Geltungsbereich</h2>
    <p>
      Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für die Nutzung der
      Software-as-a-Service-Plattform offfer.de, betrieben von Dwayne Advertising
      (siehe Impressum).
    </p>

    <h2>§ 2 Leistungsbeschreibung</h2>
    <p>
      offfer ist ein cloudbasiertes Tool zur Erstellung, Versendung und
      digitalen Annahme von Angeboten für Freelancer und Agenturen. Der genaue
      Funktionsumfang ergibt sich aus dem gewählten Tarif (Free, Pro, Business).
    </p>

    <h2>§ 3 Vertragsschluss & Probephase</h2>
    <p>
      Der Vertrag kommt mit der Registrierung und Bestätigung der E-Mail-Adresse
      zustande. In der aktuellen Beta-Phase ist die Nutzung kostenfrei.
      Bei späterer Einführung kostenpflichtiger Tarife wird der Nutzer rechtzeitig
      vor Aktivierung informiert und muss aktiv zustimmen.
    </p>

    <h2>§ 4 Pflichten des Nutzers</h2>
    <p>
      Der Nutzer ist verpflichtet, seine Zugangsdaten geheim zu halten und die
      Plattform nicht für rechtswidrige Zwecke zu missbrauchen. Insbesondere
      dürfen keine Schadprogramme, illegalen Inhalte oder unerlaubte Werbung
      über offfer verbreitet werden.
    </p>

    <h2>§ 5 Verfügbarkeit</h2>
    <p>
      Wir bemühen uns um eine möglichst hohe Verfügbarkeit der Plattform,
      garantieren in der Beta-Phase jedoch keine bestimmten Service-Level-Werte.
      Geplante Wartungsfenster werden im Voraus angekündigt.
    </p>

    <h2>§ 6 Datenschutz</h2>
    <p>
      Die Verarbeitung personenbezogener Daten ist in der{' '}
      <a href="/datenschutz" className="text-amber-600 underline">Datenschutzerklärung</a>{' '}
      geregelt.
    </p>

    <h2>§ 7 Haftung</h2>
    <p>
      Wir haften nur für Schäden aus Vorsatz und grober Fahrlässigkeit
      unbeschränkt. Bei einfacher Fahrlässigkeit haften wir nur bei Verletzung
      vertragswesentlicher Pflichten und begrenzt auf den vertragstypischen,
      vorhersehbaren Schaden. Eine Haftung für mittelbare Schäden oder entgangenen
      Gewinn ist ausgeschlossen, soweit gesetzlich zulässig.
    </p>

    <h2>§ 8 Kündigung</h2>
    <p>
      Der Nutzer kann seinen Account jederzeit über die Account-Einstellungen
      kündigen/löschen. Nach Löschung werden die Account-Daten innerhalb von
      30 Tagen unwiderruflich entfernt; davon ausgenommen sind gesetzliche
      Aufbewahrungspflichten (z.B. für Rechnungen).
    </p>

    <h2>§ 9 Änderungen der AGB</h2>
    <p>
      Wir behalten uns vor, diese AGB anzupassen. Änderungen werden den Nutzern
      mindestens 14 Tage vor Inkrafttreten in Textform angekündigt. Widerspricht
      der Nutzer nicht innerhalb von 14 Tagen, gelten die geänderten AGB als
      angenommen; auf das Widerspruchsrecht und seine Folgen wird gesondert
      hingewiesen.
    </p>

    <h2>§ 10 Schlussbestimmungen</h2>
    <p>
      Es gilt deutsches Recht. Gerichtsstand für Vollkaufleute ist München.
      Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der
      übrigen Bestimmungen unberührt.
    </p>
  </LegalLayout>
);

export default AGB;
